import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { Button,  Header,  Label,  Segment } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
import { Formik, Form } from "formik";
import { useField } from "formik";
import * as Yup from 'yup';
import MyTextInput from "../../app/common/form/MyTextInput";
import MyDateInput from "../../app/common/form/MyDateInput";
import {MySelectInput, valor, MySelectInputEdiciones} from "../../app/common/form/MySelectInput";
import { toast, ToastContainer } from 'react-toastify';
import { CuotasMod, CuotasModFormValues } from "../../app/models/CuotasMod";
import { TiposCuentas } from "../../app/common/options/TiposCuentas";
import { createCATCursos } from "../../app/models/CATCursos";
import { number } from "yup/lib/locale";
import { Check } from "@material-ui/icons";
import { ExoneracionesMod, ExoneracionesModFormValues } from "../../app/models/ExoneracionesMod";
import { isNamespaceExport } from "typescript";

 interface Props {
    names: any;   
    }

export default observer(function CreateExoneracion (props:Props) {
  
        
    const [condicion, setCondicion] = useState(false)
    const history = useHistory();
    const [aplica, setAplica]=useState(false);
    const {CCTOperacionStore, CuentaDPIStore} = useStore();
    const {createCCTOperacion, dpiByCodigo, getTransacciones, TransaccionByCodigo, TransaccionRegistry, personaDPI, kk, inputPersona, CCTCuentaByCodigo} = CCTOperacionStore;

    const {CuotasStore, modalStore} = useStore();  
    const {ExoneracionesStore} = useStore();    

    const {createExoneracionMod, transXCuenta, loading, } = ExoneracionesStore;
    //const {CATCoursesInfo,testing} = CuotasStore;
    const {loadCoursesL,} = ExoneracionesStore;
    const {loadEditions2,} = ExoneracionesStore;
    const {loadTransXTipoCta, } =CuotasStore;
    
    const name =  dpiByCodigo.map((personai:any) =>  {
       let names = personai.nombre
    });
   
    let names = props.names
    const [ExoneracionMod ] = useState<ExoneracionesModFormValues>(new ExoneracionesModFormValues());   

    

    let TiposTransXCta:object[]=[];   
 
    let ActividadAcademica:object[]=[];

    let ediciones:object[]=[];

    function handleFormSubmit(ExoneracionesMod : ExoneracionesModFormValues) {
        let date: Date = new Date();
        let id:any
        let name:any
       
        
        dpiByCodigo.map((personai:any) => {  
            id = personai.id  
            name = personai.nombre         
            let newExoneracion : ExoneracionesMod = {
                
                idcontrol : 0,
                catEdicionesId : ExoneracionesMod.catEdicionesId,
                transacciones : ExoneracionesMod.transacciones,
                userAlumnoId : id,
                solicitado_por : name,
                aprobado_por : name,
                fecha_de_solicitud : date,
                fecha_de_aprobacion : date,                     
                estado : 0,
                comentario : "",
                razon_de_solicitud : ExoneracionesMod.razon_de_solicitud,
                porcentaje_de_solicitud : ExoneracionesMod.porcentaje_de_solicitud,
                nombreCompletoAprobadopor : ""   
                                          
            }    
            createExoneracionMod(newExoneracion).then(() => {
              
            toast.success("Se a guardado correctamente.")
            modalStore.closeModal()
            
            
            }) 
            
        })
            
            }             
                   
        
          loadCoursesL().then(function(result){           
            result.forEach((element)=>{
            ActividadAcademica.push({text:element.nombre,value:element.id});
           
            })
        })             
      
                             

    const fun1 = () => {
       
                 
        if(valor()){
                                     
             ediciones=[]
             loadEditions2(valor()).then(function(result){
                result.forEach((element)=>{
                    ediciones.push({text:element.fechas, value:element.id});
                   
                })
            });
            
         TiposTransXCta = [];
            transXCuenta(valor()).then(function(result){
                 result.forEach((element)=>{
                    TiposTransXCta.push({text:element.transacciones,value:element.id});
                 })
            });
        }                      
} 


    function buscrPersona(){
        const valorInput = (document.getElementById("idCliente") as HTMLInputElement).value;
        if(valorInput.length == 13){
            personaDPI(valorInput)
            dpiByCodigo.map((personai) => { 
                                                                    
                names = personai.nombre})
        }else  {
            
        }   
    }    
            

   if (CuotasStore.loadingInitial) return <LoadingComponent content='Cargando...' />
   
    return (
        
            <div className="pagina_formulario">
                
                <Segment className="contenedor_formulario">
               
                    <Formik  
                            enableReinitialize 
                            initialValues={ExoneracionMod} 
                            onSubmit={values => handleFormSubmit(values)}>
                                
                        {({handleSubmit, isValid, isSubmitting, dirty}) => (
                            
                            <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                               
                                <Header size='large' content='Nueva Solicitud de Exoneración' style={{color:  "#538cbe", fontFamily: "Gotham"}} />
                                <br></br>
                                <div style={{marginBottom: "10px"}} >
                                    <Header size="small" content="DPI" />
                                    <input name='idCliente' id="idCliente" maxLength={13} minLength={13} onChange={buscrPersona}></input>                                   
                                    
                                    {inputPersona ?  (
                                        <Label basic color='red'>No se encuentra registrado</Label>
                                    ) : null}
                                    
                                </div>                               

                                    <div>
                                    <Header size="small" content="" />
                                    
                                    {dpiByCodigo.map((personai) => {   
                                                                    
                                         let namess = personai.nombre
                                        
                                        return(

                                            <>                                            
                                            {inputPersona ? (
                                            <MyTextInput placeholder='' name="nombre" type="text" value={names}></MyTextInput>

                                        ) : <MyTextInput placeholder='' name="nombre" type="text" value={namess}></MyTextInput>}
                                            
                                            </>

                                           
                                        )
            })}
                                  {/* <MyTextInput name='Name' placeholder='' type="text" value=""/> */}
                                   
                               
                                    </div>
                                     <br></br>       

                                <div style={{marginBottom: "10px"}} >
                                    <Header size="small" content="Actividad Académica" />
                                    <MySelectInputEdiciones name='catCodigoCurso' placeholder='' id="catCodigoCurso"  options={ActividadAcademica}  functionevent={fun1} />
                                    
                                </div><br></br>
                                <div>
                                    <Header size="small" content="Edición" />
                                                                     
                                    <MySelectInput id=" " name='catEdicionesId' placeholder='' options={ediciones} />
                                </div>  <br></br>  

                                <div>
                                    <Header size="small" content="Tipo de Transaccion" />
                                                                     
                                    <MySelectInput id=" " name='transacciones' placeholder='' options={TiposTransXCta} />
                                </div>  <br></br>                                     
                                                                 
                               

                                {/* <div>
                                    <Header size="small" content="Solicitado Por" />
                                    <MyTextInput name='solicitado_por' placeholder='' type="text"/>
                                </div>  <br></br>  */}
                                {/* <div>
                                    <Header size="small" content="Comentario" />
                                    <MyTextInput name='comentario' placeholder='' type="text"/>
                                </div>  <br></br>    */}
                                <div>
                                    <Header size="small" content="Razón de la Solicitud" />
                                    <MyTextInput name='razon_de_solicitud' placeholder='' type="text"/>
                                </div>  <br></br>                                    

                                <div>
                                    <Header size="small" content="Porcentaje de la Solicitud" />
                                    <MyTextInput name='porcentaje_de_solicitud' placeholder='25, 50 o 100%' type="number"/>
                                </div>  <br></br>       
                                                                           
                                                                                                           
                                <br></br>
                                <div>
                                    <Button
                                        loading={loading} 
                                        type='submit' 
                                        content='Guardar' 
                                        style={{backgroundColor: "#15b3e8", color: "white"}}/>
                                       
                                </div> 
                              

                                
                            </Form>
                        )} 
                    </Formik>
                    
                </Segment>
                
        </div>
    )
})
